import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CadeComponentHeader from './CadeComponentHeader';
import CadeComponentDoodle from './CadeComponentDoodle';
import CadeComponentDesc from './CadeComponentDesc';
import CadeAnalyzeRecommendations from './CadeAnalyzeRecommendations';
import CadeAnalyzeRaterComments from './CadeAnalyzeRaterComments';
import { getCadeModeForName } from '../../helpers/CadeComponentHelpers';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend } from 'recharts';

import Tour from '../../productTour/Tour';

import ReactPlayer from 'react-player';

import './CadeInput.css';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class CadeAnalyzeComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            cadeMode: props.cadeMode,
            cadeModeFor: props.cadeModeFor,
            cadeDomainId: 0,
            cadeDomain: props.cadeDomain,
            domainDisplayName: props.domainDisplayName,
            domainImage: props.cadeDomain + "LG.png",
            personFirstName: props.personFirstName,
            personLastName: props.personLastName,
            numUnansweredItems: 0,
            concernLevelIcon: null,
            concernLevel: null,
            cgName: null,
            cgComments: null,
            r1Name: null,
            r1Comments: null,
            r2Name: null,
            r2Comments: null,
            noConcerns: [],
            concerns: [],
            allItems: [],
            readonly: false
        }
    }

    componentDidMount = () => {
        /*
         * Run a query to get the domain's analysis including
         * Domain Name
         * Number of unanswered items, moderately concerned and very concerned items
         * Concern level and associated icon
         * No concern list
         * concerns list
         * recommentations list
         * rater comments
         * 
         * If the domain is incomplete (some questions not answered), pop an error message
         */

        let url = "assessment/" + this.state.assessmentId + "/domain/" + this.state.cadeDomain + "/caiu/" + authService.authenticatedUserId + "/" + this.state.cadeMode + "/" + this.state.cadeModeFor + "/uid/" + authService.authenticatedUserId;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then((response) => {
                if (response.status == 200) {
                    this.setState({
                        numUnansweredItems: response.data.numUnansweredItems,
                        concernLevel: response.data.concernLevel,
                        concernLevelIcon: response.data.concernLevelIcon,
                        noConcerns: response.data.noConcerns,
                        concerns: response.data.concerns,
                        allItems: response.data.allItems,
                        cgName: response.data.raters[2].raterName,
                        cgComments: response.data.caregiverComments,
                        r1Name: response.data.raters[0].raterName,
                        r1Comments: response.data.rater1Comments,
                        r2Name: response.data.raters[1].raterName,
                        r2Comments: response.data.rater2Comments,
                        readonly: response.data.authenticatedUserReadonly,
                        dynamicItemChange: response.data.dynamicItemChange
                    });
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    render() {
        const data = this.state.allItems.map((concern) => {
            return {
                "subject": concern.assessmentArea,
                "A": concern.rawScore,
                "fullMark": 3
            }
        });

        // No Concerns
        const noConcernsList = this.state.noConcerns.map((concern) => {
            return (
                < Row >
                    <Col sm={4}>
                        {concern.assessmentArea}
                    </Col>
                    <Col sm={8}>
                        {concern.scoringGuideDescription}
                    </Col>
                </Row >
            );
        });

        // Concerns
        const concernsList = this.state.concerns.map((concern) => {
            return (
                < Row >
                    <Col sm={4}>
                        {concern.assessmentArea}
                    </Col>
                    <Col sm={8}>
                        {concern.scoringGuideDescription}
                    </Col>
                </Row >
            );
        });
        
        // Radar color matches concern level (green, yellow, orange, red)
        let radarColor = null;
        switch (this.state.concernLevel) {
            case "No Concern":
                radarColor = "#00FF00";
                break;
            case "Mild":
                radarColor = "#ffff00";
                break;
            case "Moderate":
                radarColor = "#F9922C";
                break;
            case "Significant":
                radarColor = "#FF0000";
                break;
            default:
                // can't happen
                break;
        }

        let subTitle = "Domain Analysis";
        let who = null;

        // Depending upon the analysis mode (whose input the user wants to view), only show those comments
        let showCgComments = true;
        let showR1Comments = true;
        let showR2Comments = true;

        who = getCadeModeForName(authService.userType, this.state.cadeModeFor, this.state.r1Name, this.state.r2Name,this.state.cgName);
        if (authService.userType != this.state.cadeModeFor) {
            switch (this.state.cadeModeFor) {
                case 2:
                    break;
                
                case 3: 
                case 6:
                    showR1Comments = false;
                    showR2Comments = false;
                    break;

                case 4:
                    showCgComments = false;
                    showR2Comments = false;
                    break;

                case 5:
                    showCgComments = false;
                    showR1Comments = false;
                    break;

                default:
                    // Can't happen (clinicians can see everyone, parents can only see raters)
                    break;
            }
        }

        let domainDesc = null;
        let domainTitle = null;
        let concernPhrase = (this.state.concernLevel == "No Concern") ? this.state.concernLevel + "s" : this.state.concernLevel + " Concerns";
        if (this.state.numUnansweredItems == 0) {
            if (this.state.concernLevel != null) {
                domainTitle = concernPhrase + " about " + this.state.domainDisplayName;
                domainDesc = "";
            }
        }
        else {
            domainTitle = this.state.domainDisplayName + " Domain has Incomplete Input";
            domainDesc = "There are " + this.state.numUnansweredItems + " unanswered items in this domain.  All items must be answered prior to being analyzed.  Please return to the Input section to complete any remaining, unanswered items.";
        }

        let numDynChanges = Math.abs(this.state.dynamicItemChange);
        let dynChangeLessMore = (this.state.dynamicItemChange < 0) ? "less" : "more";
        let dynChangeVerb = (this.state.dynamicItemChange > 1) ? "are" : "is";
        let dynChangeNoun = (this.state.dynamicItemChange > 1) ? "items" : "item";
        return (
            <Fragment>
                <Tour
                    name="Analyze"
                    key="Analyze"
                />
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader
                                cadeDomain={this.state.domainDisplayName}
                                subTitle={subTitle}
                            />
                        </Col>
                        {false &&
                            <Col className="cadeComponent_videoHelp" sm={8}>
                                <Row>
                                    <Col className="cadeComponent_videoCol" sm={6}>
                                        <h6>Understanding the Analysis</h6>
                                        <div class="cadeComponent_playerWrapper">
                                            <ReactPlayer className="cadeComponent_player" url='https://vimeo.com/391597383/9869a459c3' controls={true} width='100%' height="100%" />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage={this.state.domainImage}
                                resClickHandler={null}
                                resources={null}
                                resKey={0}
                            />
                        </Col>
                        <Col sm={8}>
                                <CadeComponentDesc
                                title={domainTitle}
                                who={who}
                                desc={domainDesc}
                                titleIcon={this.state.concernLevelIcon}
                            />
                        </Col>
                    </Row>
                    {this.state.dynamicItemChange > 0 &&
                        <Row>
                            <Col sm={4}>
                            </Col>
                            <Col sm={8}>
                                <span className="cadeAnalyze_DynItemChange">
                                    There {dynChangeVerb} {numDynChanges} {dynChangeLessMore} assessment {dynChangeNoun} in this domain than in the prior assessment due to CADE's intelligent assessment technology.  Because of this, you may notice unanticipated differences in analysis and progress results.
                                </span>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col sm={12} className="tour_analyzeRadar">
                            {data.length > 0 &&
                                <ResponsiveContainer height={450}>
                                    <RadarChart outerRadius={150} data={data}>
                                        <PolarGrid />
                                        <PolarAngleAxis dataKey="subject" />
                                        <PolarRadiusAxis tick={false} axisLine={false} angle={30} domain={[0, 3]} />
                                        <Radar name="Concern Level" dataKey="A" stroke={radarColor} fill={radarColor} fillOpacity={0.7} />
                                        <Legend />
                                    </RadarChart>
                                </ResponsiveContainer>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            {data.length > 0 &&
                                <CadeAnalyzeRaterComments
                                    showCgComments={showCgComments}
                                    showR1Comments={showR1Comments}
                                    showR2Comments={showR2Comments}
                                    cgComments={this.state.cgComments}
                                    cgName={this.state.cgName}
                                    r1Comments={this.state.r1Comments}
                                    r1Name={this.state.r1Name}
                                    r2Comments={this.state.r2Comments}
                                    r2Name={this.state.r2Name}
                                />
                            }
                        </Col>
                    </Row>

                    <span className="tour_analyzeConcernLists">
                    <Row style={{ marginTop: 40 }}>
                        <Col sm={12}>
                            {noConcernsList.length > 0 &&
                                <h4>Strengths</h4>
                            }
                            {noConcernsList}
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 40 }}>
                        <Col sm={12}>
                            {concernsList.length > 0 &&
                                <h4>Areas of Concern</h4>
                            }
                            {concernsList}
                        </Col>
                        </Row>
                    </span>

                    <Row style={{ marginTop: 40 }} className="tour_analyzeRecommendations">
                        <Col sm={12}>
                            <CadeAnalyzeRecommendations
                                heading="Clear Child Recommendations"
                                concerns={this.state.concerns}
                                displayFlags={false}
                            />
                        </Col>
                   </Row>
                    
                </Container>
            </Fragment>
        )
    }
}

export default CadeAnalyzeComponent;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeAnalyzeComponent.js